<template>
  <div>
    <!-- Listagem por grupo -->
    <section
      v-for="grupoObj in dadosAgrupados"
      :key="grupoObj.grupo"
      class="box mb-5"
    >
      <div
        class="is-flex is-justify-content-space-between is-align-items-center mb-3"
      >
        <h3 class="title is-5 mb-0">{{ grupoObj.grupo }}</h3>
      </div>

      <div class="ml-4">
        <b-checkbox
          v-for="recurso in grupoObj.recursos"
          :key="recurso.id"
          v-model="recursosSelecionados"
          :native-value="recurso.id"
          class="mb-2"
        >
          {{ recurso.descricao }}
        </b-checkbox>
      </div>
    </section>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import RecursosService from "@/services/RecursosService";
import RoleService from "@/services/RoleService";

export default defineComponent({
  name: "ListRecursos",
  data() {
    return {
      dadosAgrupados: [],
      recursosSelecionados: null,
    };
  },
  async mounted() {
    await this.getRecursosByRoleId(this.$route.params.id);
    await this.getAllFeatures();
  },
  methods: {
    async getAllFeatures() {
      try {
        const response = await RecursosService.getAll();
        this.dadosAgrupados = response.data;
      } catch (error) {
        console.error("Erro ao buscar recursos:", error);
      }
    },
    async getRecursosByRoleId(roleId) {
      try {
        const response = await RoleService.getRole(roleId);
        this.recursosSelecionados = response.data.recursos.map((r) => r.id);
      } catch (error) {
        console.error("Erro ao buscar recursos da role:", error);
      }
    },

    async submit() {
      try {
        const res = await RoleService.putRole(this.$route.params.id, {
          recursosIds: this.recursosSelecionados,
        });
        console.log("Resposta:", res);
      } catch (error) {
        console.error("Erro ao enviar recursos selecionados:", error);
      }
    },
  },
  watch:{
    recursosSelecionados(newValue) {
      this.submit();
    }
  }
});
</script>

<style scoped>
.box {
  border: 1px solid #dbdbdb;
  border-radius: 8px;
  padding: 1.5rem;
  background-color: #fafafa;
}
.title.is-4,
.title.is-5 {
  font-weight: 600;
  color: #363636;
}
</style>
